import { render, staticRenderFns } from "./OrdersListTable.vue?vue&type=template&id=5bab89a0"
import script from "./OrdersListTable.vue?vue&type=script&lang=js"
export * from "./OrdersListTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersListTable.vue?vue&type=style&index=0&id=5bab89a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports